module.exports = __webpack_public_path__ + "img/book-3.de0c2138.png";